import { render, staticRenderFns } from "./SupplierProductDetailForm.vue?vue&type=template&id=55471365"
import script from "./SupplierProductDetailForm.vue?vue&type=script&lang=js"
export * from "./SupplierProductDetailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports